import { gql } from '@apollo/client';

export const activityTotalsFragment = gql`
  fragment ActivityTotals on Page {
    totals {
      timeline {
        measurementDomain
        amounts {
          unit
          value
        }
      }
      displayOptions
      primaryMeasurementType
    }
    application(type: FITNESS, name: "Strava") {
      ... on FitnessApplication {
        settings {
          measurementSystem
          showTotaliser
        }
      }
    }
  }
`;
